import React from 'react'

export default {
    localize:function(language){
    let local = new Object();
    switch (language) {
        case 'English':
        default: 
            local = {
                room: 'Room',
                category: 'Category',
                menu: 'Menu',
                additional: 'Additional',
                hello: 'Hello',
                logout: 'Logout',
                ui_mode: 'UI mode',
                about_project: 'About CONNECT',
                login: 'Login',
                password: 'Password',
                connect: 'Connect',
                authorization: 'Authorization',
                authorization_fault: 'Authorization fault',
                loading: 'Loading',
                connected: 'Connected',
                await_connection: 'Await connection',
                update_parammeters: 'Update parameters',
                update_parammeters_fault: 'Update parameters fault',
                update_configuration: 'Update configuration',
                update_configuration_fault: 'Update configuration fault',
                add_new_user: 'Add new user',
                delete_user: 'Delete user',
                delete: 'Delete',
                add: 'Add',
                users: 'Users',
                language: 'Language',
                update_users: 'Update users',
                not_selected: 'Not selected',
                off: 'Off',
                admin_delete_msg: "User admin can't be deleted!",
                software_upd: "Software update",
                software_upd_finish: "Software update finish",
                update: "Update",
                software_available: "New software is available",
                already_updated: "Software already updated",
                enter_log_pass: "Enter your Login and Password",
                // Charts
                current_temperature: "current temperature",
                comfort_temperature: "comfort temperature",
                thermostat_mode: "thermostat mode",
                red_component: "red component",
                green_component: "green component",
                blue_component: "blue component",
                brightness: "brightness",
                warm_component: "warm component",
                cold_component: "cold component",
                current_position: "current position",
                target_position: "target position",
                all_chart: "All chart",
                icon_activity_text: "0 - not active, 1 - active",
                icon_status_color_text: "0 - ok, 1 - warning, 2 - alarm"
            } 
            break;

        case 'Русский':
            local = {
                room: 'Помещение',
                category: 'Категория',
                menu: 'Меню',
                additional: 'Дополнительно',
                hello: 'Привет',
                logout: 'Выход',
                ui_mode: 'Интерфейс',
                about_project: 'Сайт CONNECT',
                login: 'Логин',
                password: 'Пароль',
                connect: 'Подключиться',
                authorization: 'Авторизация',
                authorization_fault: 'Сбой авторизации',
                loading: 'Загрузка',
                connected: 'Подключено',
                await_connection: 'Ожидание подключения',
                update_parammeters: 'Обновление параметров',
                update_parammeters_fault: 'Сбой обновления параметров',
                update_configuration: 'Обновление конфигурации',
                update_configuration_fault: 'Сбой обновления конфигурации',
                add_new_user: 'Добавить пользователя',
                delete_user: 'Удалить пользователя',
                delete: 'Удалить',
                add: 'Добавить',
                users: 'Пользователи',
                language: 'Язык',
                update_users: 'Обновление пользователей',
                not_selected: 'Не выбрано',
                off: 'Выкл.',
                admin_delete_msg: "Нельзя удалить пользователя admin!",
                software_upd: "Обновление ПО",
                software_upd_finish: "Обновление ПО завершено",
                update: "Обновить",
                software_available: "Доступно обновление ПО",
                already_updated: "ПО уже обновлено",
                enter_log_pass: "Введите Логин и Пароль",
                // Charts
                current_temperature: "текущая температура",
                comfort_temperature: "комфортная температура",
                thermostat_mode: "режим термостата",
                red_component: "красный компонент",
                green_component: "зеленый компонент",
                blue_component: "синий компонент",
                brightness: "яркость",
                warm_component: "теплый компонент",
                cold_component: "холодный компонент",
                current_position: "текущая позиция",
                target_position: "целевая позиция",
                all_chart: "Весь график",
                icon_activity_text: "0 - неактивно, 1 - активно",
                icon_status_color_text: "0 - ok, 1 - предупреждение, 2 - тревога"
            }
            break;

            case 'Español':
            local = {
                room: 'Sitio',
                category: 'Categoría',
                menu: 'Menú',
                additional: 'Adicionalmente',
                hello: 'Hola',
                logout: 'Salida',
                ui_mode: 'Interfaz',
                about_project: 'sobre el CONNECT',
                login: 'Iniciar sesión',
                password: 'Contraseña',
                connect: 'Conectar',
                authorization: 'Autorización',
                authorization_fault: 'Autorización fallida',
                loading: 'Cargando',
                connected: 'Conectado',
                await_connection: 'Esperando la conexión',
                update_parammeters: 'Actualización de parámetros',
                update_parammeters_fault: 'Error al actualizar el parámetro',
                update_configuration: 'Actualización de configuración',
                update_configuration_fault: 'Error al actualizar la configuración',
                add_new_user: 'Agregar usuario',
                delete_user: 'Borrar usuario',
                delete: 'Eliminar',
                add: 'Añadir',
                users: 'Usuarios',
                language: 'Lengua',
                update_users: 'Actualizar usuarios',
                not_selected: 'No seleccionado',
                off: "Apag.",
                admin_delete_msg: "El usuario admin no se puede eliminar",
                software_upd: "Actualización de software",
                software_upd_finish: "Finalización de la actualización de software",
                update: "Actualizar",
                software_available: "Hay nuevo software disponible",
                already_updated: "Software ya actualizado",
                enter_log_pass: "Ingrese su nombre de usuario y contraseña",
                // Charts
                current_temperature: "temperatura actual",
                comfort_temperature: "temperatura de confort",
                thermostat_mode: "modo termostato",
                red_component: "componente rojo",
                green_component: "componente verde",
                blue_component: "componente azul",
                brightness: "brillo",
                warm_component: "componente cálido",
                cold_component: "componente frío",
                current_position: "posición actual",
                target_position: "posición de objetivo",
                all_chart: "Todo el gráfico",
                icon_activity_text: "0 - no activo, 1 - activo",
                icon_status_color_text: "0 - ok, 1 - advertencia, 2 - alarma"
            }
            break;

            case '中文':
            local = {
                room: '一個地方',
                category: '类别',
                menu: '菜单',
                additional: '另外',
                hello: '你好',
                logout: '输出量',
                ui_mode: '接口',
                about_project: '關於 CONNECT',
                login: '登录',
                password: '密码',
                connect: '连接',
                authorization: '授权书',
                authorization_fault: '授权失败',
                loading: '载入中',
                connected: '连接的',
                await_connection: '等待连接',
                update_parammeters: '更新参数',
                update_parammeters_fault: '参数更新失败',
                update_configuration: '配置更新',
                update_configuration_fault: '配置更新失败',
                add_new_user: '添加用户',
                delete_user: '删除用户',
                delete: '删除',
                add: '添加',
                users: '用户数',
                language: '舌',
                update_users: '更新用戶',
                not_selected: '未選中的',
                off: "關",
                admin_delete_msg: "管理員用戶不能刪除",
                software_upd: "軟件更新",
                software_upd_finish: "軟件更新完成",
                update: "更新資料",
                software_available: "新軟件可用",
                already_updated: "軟件已更新",
                enter_log_pass: "輸入您的登錄名和密碼",
                // Charts
                current_temperature: "當前溫度",
                comfort_temperature: "舒適溫度",
                thermostat_mode: "恆溫模式",
                red_component: "紅色成分",
                green_component: "綠色成分",
                blue_component: "藍色成分",
                brightness: "亮度",
                warm_component: "溫暖的成分",
                cold_component: "冷成分",
                current_position: "當前位置",
                target_position: "目標位置",
                all_chart: "所有圖表",
                icon_activity_text: "0 - 不活动，1 - 活动",
                icon_status_color_text: "0 - 正常，1 - 警告，2 - 警报"
            }
            break;

            case 'Deutsche':
            local = {
                room: 'Zimmer',
                category: 'Kategorie',
                menu: 'Menu',
                additional: 'Zusätzlich',
                hello: 'Hallo',
                logout: 'Ausloggen',
                ui_mode: 'Benutzeroberfläche modus',
                about_project: 'Über das CONNECT',
                login: 'Login',
                password: 'Passwort',
                connect: 'Verbinden',
                authorization: 'Genehmigung',
                authorization_fault: 'Autorisierungsfehler',
                loading: 'Wird geladen',
                connected: 'In Verbindung gebracht',
                await_connection: 'Warten Sie auf die Verbindung',
                update_parammeters: 'Parameter aktualisieren',
                update_parammeters_fault: 'Fehler beim Aktualisieren der Parameter',
                update_configuration: 'Konfiguration aktualisieren',
                update_configuration_fault: 'Konfigurationsfehler aktualisieren',
                add_new_user: 'Neuen Benutzer hinzufügen',
                delete_user: 'Benutzer löschen',
                delete: 'Löschen',
                add: 'Hinzufügen',
                users: 'Benutzer',
                language: 'Sprache',
                update_users: 'Benutzer aktualisieren',
                not_selected: 'Nicht ausgewählt',
                off: 'Aus',
                admin_delete_msg: "Benutzer admin kann nicht gelöscht werden!",
                software_upd: "Software update",
                software_upd_finish: "Software update beendet",
                update: "Aktualisieren",
                software_available: "Neue Software ist verfügbar",
                already_updated: "Software bereits aktualisiert",
                enter_log_pass: "Geben Sie Ihren Login und Ihr Passwort ein",
                // Charts
                current_temperature: "aktuelle temperatur",
                comfort_temperature: "komforttemperatur",
                thermostat_mode: "thermostatmodus",
                red_component: "rote komponente",
                green_component: "grüne komponente",
                blue_component: "blaue komponente",
                brightness: "helligkeit",
                warm_component: "warme komponente",
                cold_component: "kalte komponente",
                current_position: "aktuelle position",
                target_position: "zielposition",
                all_chart: "Alle Diagramme",
                icon_activity_text: "0 - nicht aktiv, 1 - aktiv",
                icon_status_color_text: "0 – OK, 1 – Warnung, 2 – Alarm"
            } 
            break;
        }
        return local;
    },

    languages: ['English', 'Español', 'Русский', '中文', 'Deutsche']

}